import SubscriptionPlan from "types/enums/SubscriptionPlan"

const subscriptionPlanFeatures: {
  name: string
  [SubscriptionPlan.E_PLUS]: string
  [SubscriptionPlan.NETWORK]: string
  [SubscriptionPlan.PLUS]: string
  [SubscriptionPlan.PLUS_MAY_2025]: string
  [SubscriptionPlan.BASIC]: string
  [SubscriptionPlan.BASIC_MAY_2025]: string
  [SubscriptionPlan.SUPREME]: string
  [SubscriptionPlan.BASIC_OCT_2025]: string
  [SubscriptionPlan.GROWTH]: string
}[] = [
  {
    name: "Logo",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
  },
  {
    name: "Email - Thermostat Alerts",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
  },
  {
    name: "Nuve Dashboard Center",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "24/7 Monitoring",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Alerts Management",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Remote Performance Test",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Messaging Center",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.PLUS_MAY_2025]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Marketing Center",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Monthly Monitoring Call",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Custom App Icon",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Custom Application",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Custom Dashboard",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Contractor University",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Dealer Meeting Comp (2)",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
  {
    name: "Nuve Intelligence Reporting",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.PLUS_MAY_2025]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
  },
]

export default subscriptionPlanFeatures
